import { AppList } from "components/list/AppList";
import { useGridUserDataGlobalFiltersContext } from "contexts/GridUserDataGlobalFiltersProvider";
import { RevenueSource } from "entities/RevenueSource";
import React from "react";

import { stylesForColorInheritInList } from "../../../components/_helpers/useStyles";
import { getDateWithMonthOffset } from "../../../utils/datetime";
import { FinancialCharts } from "./FinancialCharts";
import { GroupingPeriodEnum } from "./GroupingPeriodFilter";
import { RevenueAndExpensesChartFilter } from "./ListFilters";

const defaultFilters = {
	grouping_period: [GroupingPeriodEnum.MONTH],
	date_from: getDateWithMonthOffset(undefined, 12, true),
	date_to: getDateWithMonthOffset(),
	revenue_source: RevenueSource.ALL,
};

export const RevenueAndExpensesList = ({ permissions, ...props }) => {
	const classes = stylesForColorInheritInList();
	const { data: globalFilters = {}, isLoading } = useGridUserDataGlobalFiltersContext();

	if (isLoading) return null;

	const globalFilter = { terminal_id: globalFilters?.terminal_id };

	return (
		<AppList
			{...props}
			exporter={false}
			bulkActionButtons={false}
			filters={<RevenueAndExpensesChartFilter terminalId={globalFilters?.terminal_id?.[0]} />}
			classes={classes}
			pagination={false}
			filter={globalFilter}
			filterDefaultValues={{ ...defaultFilters, ...globalFilter }}
		>
			<FinancialCharts {...props} />
		</AppList>
	);
};
